/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `purchase` - Purchase
* `sales` - Sales
 */
export type OperationReportTypeEnum = typeof OperationReportTypeEnum[keyof typeof OperationReportTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OperationReportTypeEnum = {
  purchase: 'purchase',
  sales: 'sales',
} as const;
